import { connect } from 'react-redux'
import React from 'react'
import Roles from '../models/Roles'
import PlayerPage from '../components/PlayerPage'
import HostPage from '../containers/HostPage'
import EditorPage from '../containers/EditorPage'
import DevPage from './DevPage'
import Login from '../containers/Login'
import ResetPassword from '../components/ResetPassword'

class MainPage extends React.Component  {
    state = {
        isLogged : false, 
        resetPasswordToken : null
    }

    componentDidMount(){
        this.setState({isLogged:this.props.user.isLogged, 
                      resetPasswordToken: this.props.resetPasswordToken});
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user !== this.props.user)
        this.setState({isLogged:this.props.user.isLogged, 
                     resetPasswordToken : this.props.resetPasswordToken});
    }

    render(){
        const {user,socket} = this.props;
        const {roles } = user
        const {isLogged, resetPasswordToken} = this.state
        const isDev = roles && roles.indexOf(Roles.DEV) !== -1
        const isPlayer = roles && roles.indexOf(Roles.PLAYER) !== -1
        const isHost = roles && roles.indexOf(Roles.HOST) !== -1
        const isEditor = roles && roles.indexOf(Roles.EDITOR) !== -1 
    
        if (!isLogged){
            if (resetPasswordToken){
                return (
                    <div style={{ minHeight: '100%', position: 'relative' }}>
                        <ResetPassword socket={socket} user = {this.props.username} resetPasswordToken={resetPasswordToken}/>
                    </div>    
                )
            }else{
                return (
                <div style={{ minHeight: '100%', position: 'relative' }}>
                    <Login socket={socket} />
                </div>
                )
            }
        }
        if (isPlayer){
            return <PlayerPage socket={socket} isLogged={isLogged} user={user}/>
        }
        if (isDev)
            return <DevPage />
        if (isHost)
           return <HostPage socket={socket} />
        if (isEditor)
            return <EditorPage socket={socket} />
    
        return <div>Non hai nessun ruolo</div>
    }
    
   
}

const mapStateToProps = state => ({
    socket: state.socket,
    user: state.user,
    resetPasswordToken: state.resetPasswordToken
})

export default connect(
    mapStateToProps
)(MainPage)


// WEBPACK FOOTER //
// ./src/components/MainPage.js